import {AppointmentApiDto, CreateUpdateAppointmentApiDto} from "../../api/model/rest";
import JsonConverter from "../../api/helper/JsonConverter";
import AppointmentStatus, {AppointmentStatusEnum} from "./AppointmentStatus";
import {none, option, Option} from "ts-option";
import AppointmentType from "./AppointmentType";
import {getAppointmentType} from "../../store/view/appointment";
import moment = require("moment");

const uuidv4 = require("uuid/v4");

export default class Appointment {

	constructor(public readonly id: string,
		public readonly dateTime: moment.Moment,
		public readonly endDateTime: moment.Moment,
		public readonly duration: number,
		public readonly status: AppointmentStatus,
		public readonly typeId: Option<string>,
		public readonly type: Option<AppointmentType>,
		public readonly leadId: Option<string>,
		public readonly referenceNumber: Option<string>,
		public readonly assigneeId: Option<string>) {}

	static fromJson(json: AppointmentApiDto): Appointment {
		const typeId = option(json.typeId);
		const type = typeId.isDefined ? getAppointmentType(json.typeId) : none;
		const startDateTime = moment(json.dateTime);
		const endDateTime = moment(json.endDateTime);
		const duration = moment(endDateTime).diff(moment(startDateTime), "minutes");
		return new Appointment(json.id, startDateTime, endDateTime, duration, AppointmentStatus.fromString(json.status),
			typeId, type, option(json.leadId), option(json.referenceNumber), option(json.assigneeId))
	}

	getDate(): moment.Moment {
		return moment(this.dateTime).startOf("day");
	}

	toJson() {
		const json: CreateUpdateAppointmentApiDto = {
			dateTime: this.dateTime.format(),
			endDateTime: this.endDateTime.format(),
			status: this.status.value,
			typeId: this.typeId.orNull,
			assigneeId: this.assigneeId.orNull
		};
		return JsonConverter.removeEmptyFields(json);
	}

	copy({dateTime = this.dateTime,  status = this.status, type = this.type, assigneeId = this.assigneeId, duration = this.duration}) {
		const endDateTime = moment(dateTime).add(duration, "minutes");
		return new Appointment(this.id, dateTime, endDateTime, duration, status, type.map(t => t.id), type, this.leadId,
			this.referenceNumber, assigneeId)
	}

	static create(dateTime: moment.Moment, type: Option<AppointmentType>, assigneeId: Option<string>, duration: number) {
		const endDateTime = moment(dateTime).add(duration, "minutes");
		return new Appointment(uuidv4(), dateTime, endDateTime, duration,
			AppointmentStatus.fromString(AppointmentStatusEnum.Unconfirmed),
			type.map(t => t.id), type, none, none, assigneeId);
	}

	public static compare(a: Appointment, b:Appointment){
		return a.dateTime.diff(b.dateTime);
	}
}